export default "__VITE_ASSET__t9lhjls6__"